import { render, staticRenderFns } from "./IconMigration.vue?vue&type=template&id=5e744846&scoped=true"
import script from "./IconMigration.vue?vue&type=script&lang=js"
export * from "./IconMigration.vue?vue&type=script&lang=js"
import style0 from "./IconMigration.vue?vue&type=style&index=0&id=5e744846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e744846",
  null
  
)

export default component.exports